import React, { useRef, useEffect } from 'react';
import css from './index.module.css';

import jsLogo from '@assets/companies/js.svg';
import linuxLogo from '@assets/companies/linux.svg';
import apiLogo from '@assets/companies/api.svg';
import dockerLogo from '@assets/companies/docker.svg';
import cssLogo from '@assets/companies/css.svg';
import htmlLogo from '@assets/companies/html.svg';
import gitLogo from '@assets/companies/git.svg';

const CARD_DATA = [
    { id: 253298, title: 'JavaScript', type: 'Продвинутый уровень', link: 'https://cdn-a.leecyber.com/tartikov/js.pdf', logo: jsLogo },
    { id: 253330, title: 'Linux', type: 'Продвинутый уровень', link: 'https://cdn-a.leecyber.com/tartikov/linux.pdf', logo: linuxLogo },
    { id: 253313, title: 'API', type: 'Продвинутый уровень', link: 'https://cdn-a.leecyber.com/tartikov/api.pdf', logo: apiLogo },
    { id: 253329, title: 'Docker', type: 'Продвинутый уровень', link: 'https://cdn-a.leecyber.com/tartikov/docker.pdf', logo: dockerLogo },
    { id: 253312, title: 'CSS', type: 'Продвинутый уровень', link: 'https://cdn-a.leecyber.com/tartikov/css.pdf', logo: cssLogo },
    { id: 253328, title: 'HTML', type: 'Продвинутый уровень', link: 'https://cdn-a.leecyber.com/tartikov/html.pdf', logo: htmlLogo },
    { id: 253331, title: 'GIT', type: 'Продвинутый уровень', link: 'https://cdn-a.leecyber.com/tartikov/git.pdf', logo: gitLogo },
];

const carouselAnimation = `
@keyframes infiniteScroll {
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}
`;

const Card = ({ card }) => (
    <a className={css.card} href={card.link} target='_blank'>
        <img src={card.logo} alt={card.title} className={css.cardIcon} />
        <h3 className={css.cardTitle}>{card.title}</h3>
        <span className={css.cardType}>{card.type}</span>
        <div className={css.cardCert}>
            <i className="fi fi-rr-check-circle"></i>
            <span>Сертификат №{card.id}</span>
        </div>
    </a>
);

const App = () => {
    const carouselRef = useRef(null);
    const maxCarouselWrapperWidth = 1120;
    // Увеличиваем количество повторений для бесконечного эффекта прокрутки
    // (4* CARD_DATA.length — достаточно для длинной ленты на любом экране)
    const carouselItems = [
        ...CARD_DATA,
        ...CARD_DATA,
        ...CARD_DATA,
        ...CARD_DATA
    ];

    useEffect(() => {
        if (carouselRef.current) {
            carouselRef.current.style.animationPlayState = 'running';
        }
    }, []);

    const handleMouseEnter = () => {
        if (carouselRef.current) {
            carouselRef.current.style.animationPlayState = 'paused';
        }
    };

    const handleMouseLeave = () => {
        if (carouselRef.current) {
            carouselRef.current.style.animationPlayState = 'running';
        }
    };

    return (
        <>
            <style>{carouselAnimation}</style>
            <div
                style={{
                    width: '100%',
                    maxWidth: maxCarouselWrapperWidth,
                    overflow: 'hidden',
                    marginLeft: 10 
                }}
            >
                <div
                    ref={carouselRef}
                    style={{
                        display: 'flex',
                        width: 'max-content',
                        animation: 'infiniteScroll 120s linear infinite',
                        alignItems: 'stretch',
                        gap: 20
                    }}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                >
                    {carouselItems.map((item, idx) => (
                        <Card
                            key={idx}
                            card={item}
                        />
                    ))}
                </div>
            </div>
        </>
    );
};

export default App;